import type { AppLayoutKind } from "@ui/layouts/layoutProvider";
import type { ListBoardItemResponse } from "@/client";

const detailsRouteMap: Record<AppLayoutKind, string> = {
	account: "/account",
	admin: "/boards",
	askgvt: "/boards",
	studio: "/studio/boards",
	roster: "/roster/boards",
	labs: "/projects/:projectId/boards",
	"agency-hub": "/roster/boards",
};

export function boardDetailsRouteNeedsProject(appKind: AppLayoutKind): boolean {
	return detailsRouteMap[appKind].includes(":projectId");
}

export function boardDetailsBasePath(
	appKind: AppLayoutKind,
	projectId?: string,
): string {
	return detailsRouteMap[appKind].replace(":projectId", projectId ?? "");
}

export function buildBoardDetailsUrl(
	basePath: string,
	board: ListBoardItemResponse,
): string {
	const boardId = board.id;
	if (!boardId) {
		return basePath;
	}

	const path = `${basePath}/${boardId}`;
	const clipId = board.thumbnail_images?.[0]?.public_id;
	if (!clipId) {
		return path;
	}

	return `${path}?clip_id=${encodeURIComponent(clipId)}`;
}
